package com.arena_web.utils

import androidx.compose.runtime.*
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.collect

@Composable
fun <T> StateFlow<T>.collectAsState(): State<T> {
    val state = remember(this) { mutableStateOf(value) }

    LaunchedEffect(this) {
        collect { newValue ->

            if (state.value != newValue) {
                state.value = newValue
            }
        }
    }

    return state
}

fun <T> T?.orDefault(default: T): T = this ?: default

inline fun <T> T?.ifNotNull(block: (T) -> Unit) {
    if (this != null) block(this)
}

inline fun <T> T?.ifNull(block: () -> Unit) {
    if (this == null) block()
}

/**
 * Converts a local date + time string (e.g. "2025-04-11" + "22:00")
 * to a UTC ISO 8601 string (e.g. "2025-04-11T19:00:00.000Z" for UTC+3).
 */
fun localToUtcIso(date: String, time: String): String {
    val jsDate = js("new Date(date + 'T' + time + ':00')") as kotlin.js.Date
    return jsDate.toISOString() as String
}

@Composable
fun <T> rememberWithStorage(
    key: String,
    defaultValue: T,
    save: (String, T) -> Unit,
    load: (String) -> T?
): State<T> {
    val stored = remember { load(key) ?: defaultValue }
    var state by remember { mutableStateOf(stored) }

    LaunchedEffect(state) {
        if (state != stored) {
            save(key, state)
        }
    }

    return remember(state) { mutableStateOf(state) }
}
